import { v4 as uuid } from 'uuid'
import { Api } from '../../Utils/api'
import { ContaAReceber, ContaAReceberAttributes, contaAReceberLiquidar, DadosBordero, DadosImpressaoBordero, DadosRelCtaReceber, DadosRelCtaReceberEstorno, error99, LanctoFormaPag, ParamsEstDupReceber, RetAPI, taxaAttributes } from "../../Utils/Types"
import { encode as base64_encode } from 'base-64'

export const ContaAReceberService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('DupReceber/GetAttributes', 'get', { id })
        const attributes: ContaAReceberAttributes = {
            cliente: [],
            contaAReceber: {
                id: 0,
                data_vencimento: '',
                id_cliente: 0,
                serie: 0,
                id_venda: 0,
                observacao: '',
                valor: 0,
                valor_original: 0,
                id_user_insert: 0,
                dt_cadastro: '',
                id_user_last_update: 0,
                dt_last_update: '',
                id_user_baixa: 0,
                dt_baixa: '',
                vl_desconto: 0,
                vl_juros: 0,
                id_user_cancel: 0,
                dh_cancel: '',
                motivo_cancel: '',
                obs_baixa: '',
                name_user_insert: '',
                name_user_baixa: '',
                name_user_cancel: '',
                name_user_last_update: ''
            }
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.cliente) {

                    resp.data.cliente.map((item: any) => {
                        attributes.cliente?.push(
                            {
                                id: item.id,
                                description: item.nome,

                            }
                        )
                    })
                }

                if (resp.data.duplicata) {

                    attributes.contaAReceber.id = resp.data.duplicata.id
                    attributes.contaAReceber.data_vencimento = resp.data.duplicata.data_vencimento
                    attributes.contaAReceber.id_cliente = resp.data.duplicata.id_cliente
                    attributes.contaAReceber.serie = resp.data.duplicata.serie
                    attributes.contaAReceber.id_venda = resp.data.duplicata.id_venda
                    attributes.contaAReceber.observacao = resp.data.duplicata.observacao
                    attributes.contaAReceber.valor = resp.data.duplicata.valor
                    attributes.contaAReceber.valor_original = resp.data.duplicata.valor_original
                    attributes.contaAReceber.id_user_insert = resp.data.duplicata.id_user_insert
                    attributes.contaAReceber.dt_cadastro = resp.data.duplicata.dt_cadastro
                    attributes.contaAReceber.id_user_last_update = resp.data.duplicata.id_user_last_update
                    attributes.contaAReceber.dt_last_update = resp.data.duplicata.dt_last_update
                    attributes.contaAReceber.id_user_baixa = resp.data.duplicata.id_user_baixa
                    attributes.contaAReceber.dt_baixa = resp.data.duplicata.dt_baixa
                    attributes.contaAReceber.vl_desconto = resp.data.duplicata.vl_desconto
                    attributes.contaAReceber.vl_juros = resp.data.duplicata.vl_juros
                    attributes.contaAReceber.id_user_cancel = resp.data.duplicata.id_user_cancel
                    attributes.contaAReceber.dh_cancel = resp.data.duplicata.dh_cancel
                    attributes.contaAReceber.motivo_cancel = resp.data.duplicata.motivo_cancel
                    attributes.contaAReceber.obs_baixa = resp.data.duplicata.obs_baixa
                    attributes.contaAReceber.name_user_insert = resp.data.duplicata.name_user_insert
                    attributes.contaAReceber.name_user_last_update = resp.data.duplicata.name_user_last_update

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }
    },

    Save: async (dupReceber: any): Promise<RetAPI> => {

        let id = ''

        if (dupReceber.id) {
            id = dupReceber.id.toString()
        }

        const resp = await Api('DupReceber/Save', 'post', {

            data_vencimento: dupReceber.data_vencimento,
            id_cliente: dupReceber.id_cliente,
            serie: dupReceber.serie,
            valor: dupReceber.valor,
            observacao: dupReceber.observacao,
            id

        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: 'Dados da duplicata gravados com sucesso',
                id: resp.data.duplicata.id,
                data: resp.data,
                dt_cadastro: resp.data.duplicata.dt_cadastro,
                dt_last_update: resp.data.duplicata.dt_last_update,
                name_user_insert: resp.data.duplicata.name_user_insert,
                name_user_last_update: resp.data.duplicata.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    Delete: async (id_duplicata: number, motivo: string, senha_usuario: string): Promise<RetAPI> => {

        const random = uuid()

        senha_usuario = base64_encode(senha_usuario + '-' + random)

        const resp = await Api(`DupReceber/Delete?id=${id_duplicata}&motivo=${motivo}&senha=${senha_usuario}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (filterDupReceber?: any): Promise<RetAPI> => {

        const resp = await Api('DupReceber/Filter', 'get', {
            id_cliente: filterDupReceber.id_cliente, 
            datai: filterDupReceber.datai, 
            dataf: filterDupReceber.dataf, 
            tipo_filtro: filterDupReceber.tipo_filtro
        })


        const dadosRel: DadosRelCtaReceber = { ctaReceber: [], qtdDup: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosRel.qtdDup = resp.data.quantidade_total
                dadosRel.total = resp.data.valor_total

                resp.data.duplicatas.map((item: any) => {
                    return dadosRel.ctaReceber.push({

                        id: item.id,
                        data_vencimento: item.data_vencimento,
                        id_cliente: item.id_cliente,
                        serie: item.serie,
                        id_venda: item.id_venda,
                        observacao: item.observacao,
                        valor: item.valor,
                        valor_original: item.valor_original,
                        id_user_insert: item.id_user_insert,
                        dt_cadastro: item.dt_cadastro,
                        id_user_last_update: item.id_user_last_update,
                        dt_last_update: item.dt_last_update,
                        id_user_baixa: item.id_user_baixa,
                        dt_baixa: item.dt_baixa,
                        vl_desconto: item.vl_desconto,
                        vl_juros: item.vl_juros,
                        id_user_cancel: item.id_user_cancel,
                        dh_cancel: item.dh_cancel,
                        motivo_cancel: item.motivo_cancel,
                        obs_baixa: item.obs_baixa,
                        name_user_insert: item.nome_user_insert,
                        name_user_baixa: item.nome_user_baixa,
                        name_user_cancel: item.nome_user_cancel,
                        name_user_last_update: item.nome_last_update,
                        nome_cliente: item.nome,
                        id_bordero: item.id_bordero

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dadosRel,
        }

    },

    FilterBordero: async (filterDupReceber?: any): Promise<RetAPI> => {

        const resp = await Api('DupReceber/Filter/Bordero', 'get', {
            datai: filterDupReceber?.datai,
            dataf: filterDupReceber?.dataf,
            id_cliente: filterDupReceber?.id_cliente,
            bordero: filterDupReceber?.bordero
        })
        const dadosRel: DadosRelCtaReceberEstorno = { ctaReceber: [], qtdDup: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosRel.total = resp.data.valor_total
                dadosRel.qtdDup = resp.data.quantidade_total

                resp.data.duplicatas.map((item: any) => {
                    return dadosRel.ctaReceber.push({

                        id: item.id_bordero,
                        qtdDup: item.qtd,
                        id_bordero: item.id_bordero,
                        valor: item.valor,
                        nome: item.nome

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dadosRel,
        }

    },

    FilterExcluidas: async (filterDupReceber?: any): Promise<RetAPI> => {

        const resp = await Api('DupReceber/Filter/Excluidas', 'get', {
            datai: filterDupReceber.datai,
            dataf: filterDupReceber.dataf,
            nome_cliente: filterDupReceber.nome_cliente
        })
        const dadosRelExcluidos: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRelExcluidos
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.duplicatas.map((item: any) => {
                    return dadosRelExcluidos.push({
                        id: item.id,
                        id_user_cancel: item.id_user_cancel,
                        dh_cancel: item.dh_cancel,
                        motivo_cancel: item.motivo_cancel,
                        name_user_cancel: item.name_user_cancel,
                        nome_cliente: item.nome,
                        valor_original: item.valor_original,
                        valor: item.valor,
                        serie: item.serie

                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRelExcluidos
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dadosRelExcluidos,
        }

    },

    Liquidar: async (dados: contaAReceberLiquidar): Promise<RetAPI> => {

        const random = uuid()

        const resp = await Api('DupReceber/Liquidar', 'put', {

            tipo_baixa: dados.tipo_baixa,
            id_cliente: dados.id_cliente,
            valor_baixa: dados.valor_baixa,
            valor_juros: dados.valor_juros,
            taxa_juros: dados.taxa_juros,
            diasJuros: dados.diasJuros,
            valor_desconto: dados.valor_desconto,
            dtpagto: dados.dtpagto,
            senha_usuario: base64_encode(dados.senha_usuario + '-' + random),
            observacao: dados.observacao,
            duplicatas: dados.duplicatas,
            pagamentos: dados.pagamentos,

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || ''
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',
                data: resp.data
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Estornar: async (params: ParamsEstDupReceber): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('DupReceber/Estornar', 'put', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || ''
                }
            }

            return {
                error: false,
                msg: resp.data.msg || '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }

        }

    },

    RelatorioBordero: async (id_cliente: number, datai: string, dataf: string): Promise<RetAPI> => {

        const resp = await Api('DupReceber/RelBorderoLiquidados', 'get', { id_cliente, datai, dataf })
        const dadosRel: DadosBordero[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.duplicatas.map((item: any) => {
                    return dadosRel.push({

                        valor: item.valor,
                        id_bordero: item.id_bordero,
                        dt_baixa: item.dt_baixa,
                        name_user: item.name_user,
                        name_cliente: item.nome,
                        obs_baixa: item.obs_baixa

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }
        }

        return {
            error: false,
            data: dadosRel
        }

    },

    ImprimirBordero: async (bordero: number): Promise<RetAPI> => {

        const resp = await Api('DupReceber/DadosBorderoImpresso', 'get', { bordero })
        const dadosRel: DadosImpressaoBordero = {
            duplicata: [],
            clientes: {
                id: 0,
                nome: '',
                endereco: '',
                bairro: '',
                numero: 0,
                cep: '',
                id_cidade: 0,
                uf: '',
                tipo_pessoa: '',
                cnpj_cpf: '',
                ie_rg: '',
                complemento: '',
                observacao: '',
                dt_cadastro: '',
                ativo: '',
                id_empresa: 0,
                id_user_insert: 0,
                nome_fantasia: '',
                id_user_last_update: 0,
                dt_last_update: '',
                dt_nascimento: '',
                dh_exclusao: '',
                id_user_exclusao: 0,
                motivo_exclusao: '',
                description: '',
                nome_cidade: ''

            },
            pagamentos: []
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.duplicatas) {

                    resp.data.duplicatas.map((item: any) => {
                        return dadosRel.duplicata.push({

                            id: item.id,
                            data_vencimento: item.data_vencimento,
                            id_cliente: item.id_cliente,
                            serie: item.serie,
                            id_venda: item.id_venda,
                            observacao: item.observacao,
                            valor: item.valor,
                            valor_original: item.valor_original,
                            id_user_insert: item.id_user_insert,
                            dt_cadastro: item.dt_cadastro,
                            id_user_last_update: item.id_user_last_update,
                            dt_last_update: item.dt_last_update,
                            id_user_baixa: item.id_user_baixa,
                            dt_baixa: item.dt_baixa,
                            vl_desconto: item.vl_desconto,
                            vl_juros: item.vl_juros,
                            id_user_cancel: item.id_user_cancel,
                            dh_cancel: item.dh_cancel,
                            motivo_cancel: item.motivo_cancel,
                            obs_baixa: item.obs_baixa,
                            id_bordero: item.id_bordero,
                            id_origem: item.id_origem,
                            name_user_insert: item.nome_user_insert,
                            name_user_baixa: item.nome_user_baixa,
                            name_user_cancel: item.nome_user_cancel,
                            name_user_last_update: item.nome_last_update

                        })
                    })
                }

                if (resp.data.cliente) {

                    dadosRel.clientes.id = resp.data.cliente.id
                    dadosRel.clientes.nome = resp.data.cliente.nome
                    dadosRel.clientes.endereco = resp.data.cliente.endereco
                    dadosRel.clientes.bairro = resp.data.cliente.bairro
                    dadosRel.clientes.numero = resp.data.cliente.numero
                    dadosRel.clientes.cep = resp.data.cliente.cep
                    dadosRel.clientes.id_cidade = resp.data.cliente.id_cidade
                    dadosRel.clientes.uf = resp.data.cliente.uf
                    dadosRel.clientes.tipo_pessoa = resp.data.cliente.tipo_pessoa
                    dadosRel.clientes.cnpj_cpf = resp.data.cliente.cnpj_cpf
                    dadosRel.clientes.ie_rg = resp.data.cliente.ie_rg
                    dadosRel.clientes.complemento = resp.data.cliente.complemento
                    dadosRel.clientes.observacao = resp.data.cliente.observacao
                    dadosRel.clientes.dt_cadastro = resp.data.cliente.dt_cadastro
                    dadosRel.clientes.ativo = resp.data.cliente.ativo
                    dadosRel.clientes.id_empresa = resp.data.cliente.id_empresa
                    dadosRel.clientes.id_user_insert = resp.data.cliente.id_user_insert
                    dadosRel.clientes.nome_fantasia = resp.data.cliente.nome_fantasia
                    dadosRel.clientes.id_user_last_update = resp.data.cliente.id_user_last_update
                    dadosRel.clientes.dt_last_update = resp.data.cliente.dt_last_update
                    dadosRel.clientes.dt_nascimento = resp.data.cliente.dt_nascimento
                    dadosRel.clientes.dh_exclusao = resp.data.cliente.dh_exclusao
                    dadosRel.clientes.id_user_exclusao = resp.data.cliente.id_user_exclusao
                    dadosRel.clientes.motivo_exclusao = resp.data.cliente.motivo_exclusao
                }

                if (resp.data.pagamentos) {

                    resp.data.pagamentos.map((item: any) => {
                        return dadosRel.pagamentos.push({
                            valor: item.valor,
                            descricao: item.descricao
                        })
                    })

                }

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }

        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dadosRel
        }

    },

    BuscarTaxa: async (): Promise<RetAPI> => {

        const resp = await Api('DupReceber/Taxa', 'get')
        const dadosTaxa: taxaAttributes = {
            id: 0,
            id_empresa: 0,
            id_user_insert: 0,
            id_user_last_update: 0,
            dt_cadastro: '',
            dt_last_update: '',
            taxa_juros: 0
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosTaxa
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.taxa.map((item: any) => {

                    dadosTaxa.id = item.id
                    dadosTaxa.id_empresa = item.id_empresa
                    dadosTaxa.id_user_insert = item.id_user_insert
                    dadosTaxa.id_user_last_update = item.id_user_last_update
                    dadosTaxa.dt_last_update = item.dt_last_update
                    dadosTaxa.dt_cadastro = item.dt_cadastro
                    dadosTaxa.taxa_juros = item.taxa_juros
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosTaxa
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dadosTaxa,
        }

    },

    BuscarPagamentos: async (bordero: number[]): Promise<RetAPI> => {

        const resp = await Api(`DupReceber/DadosPag?bordero=${bordero}`, 'get',)
        const dados: LanctoFormaPag[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dados
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.pagRecebidos.map((item: any) => {
                    return dados.push({
                        description: item.descricao,
                        id_fpagto: item.id_fpagto,
                        valor: item.valor,
                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dados
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dados,
        }

    }
}